import axios from "axios";
import Cookies from "universal-cookie";

const apiURL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_BACKEND_API_URL;

const cookies = new Cookies();
const token = cookies.get("TOKEN");
// const userID = cookies.get("USER_ID");
axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

export const getBuyersService = async () => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/buyers`);
  return res;
};

export const postBuyerService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.createdByUserID = userID;
  const res = await axios.post(`${apiURL}/metalstrading/api/buyers`, payload);
  return res;
};

export const putBuyerService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.updatedByUserID = userID;
  const res = await axios.put(`${apiURL}/metalstrading/api/buyers/${payload.buyerID}`, payload);
  return res;
};
